<template>
  <div class="card_ventas">
    <div class="grey_background">
      <div class="card_header">
        <div class="header_left">
          <span class="period_text">{{ period }}</span>
        </div>
        <div class="header_right">
          <span v-if="mom" class="pill pill_green">{{ mom }} MoM</span>
          <span v-if="yoy" class="pill pill_light_green">{{ yoy }} YoY</span>
        </div>
      </div>

      <div class="main_amount mt-2 is-flex is-justify-content-space-between is-align-items-center">
        <span>{{ formatMoney(amount) }}</span>
        <slot name="extra"></slot>
      </div>
    </div>

    <div class="bottom_section mt-2">
      <ProgressBarSection :items="progressItems" />
    </div>
  </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import ProgressBarSection from "./ProgressBarSection.vue";

export default {
  name: 'CardVentas',
  components: {
    ProgressBarSection
  },
  props: {
    period: String,
    amount: Number,
    mom: String,
    yoy: String,
    progressItems: Array
  },
  methods: {
    formatMoney(val) {
      return parseToMoney(val);
    }
  }
}
</script>

<style scoped lang="scss">
.card_ventas {
  padding: 12px 12px 5px 12px;
  background: #FFF;
  border-radius: 16px;
  border: 1px solid var(--report-border, #EBEBEB);
  flex: 1;
  min-width: 320px;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
}

.grey_background {
  padding: 16px 12px;
  background: var(--report-surface, #EAECF0);
  border-radius: 16px;
  border: 1px solid var(--report-border, #EBEBEB);
}

.card_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.period_text {
  color: var(--report-text-muted, #5C5C5C);
  font-size: 14px;
  font-weight: 500;
}

.pill {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
}

.pill_green {
  background: var(--report-pill-bg, #EDFDFE);
  color: var(--report-pill-text, #157389);
  border: 1px solid var(--report-accent-border, #AAF1F7);
}

.pill_light_green {
  background: var(--report-pill-bg, #EDFDFE);
  color: var(--report-pill-text, #157389);
  border: 1px solid var(--report-accent-border, #AAF1F7);
}

.main_amount {
  font-size: 32px;
  font-weight: 500;
  color: var(--report-text, #171717);
  letter-spacing: -0.16px;
}

.bottom_section {
  padding: 0 4px;
}
</style>
